export default __webpack_public_path__ + "js/components/liveClassPurchasePage/component/BenefitScreen/tick-35056a879cf7494111d55e26fde36c10.svg";